var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 11.8916V15.3337C21.6667 15.8004 21.6667 16.0338 21.7575 16.212C21.8374 16.3688 21.9649 16.4963 22.1217 16.5762C22.3 16.6671 22.5333 16.6671 23 16.6671H26.4422M21.6667 24.167H16.6667M23.3334 20.8337H16.6667M26.6667 18.3238V24.3337C26.6667 25.7338 26.6667 26.4339 26.3942 26.9686C26.1545 27.439 25.7721 27.8215 25.3017 28.0612C24.7669 28.3337 24.0668 28.3337 22.6667 28.3337H17.3334C15.9332 28.3337 15.2332 28.3337 14.6984 28.0612C14.228 27.8215 13.8455 27.439 13.6059 26.9686C13.3334 26.4339 13.3334 25.7338 13.3334 24.3337V15.667C13.3334 14.2669 13.3334 13.5668 13.6059 13.032C13.8455 12.5616 14.228 12.1792 14.6984 11.9395C15.2332 11.667 15.9332 11.667 17.3334 11.667H20.0099C20.6213 11.667 20.9271 11.667 21.2148 11.7361C21.4699 11.7973 21.7137 11.8983 21.9374 12.0354C22.1897 12.19 22.4059 12.4062 22.8383 12.8386L25.4951 15.4954C25.9275 15.9278 26.1437 16.144 26.2983 16.3963C26.4354 16.62 26.5364 16.8638 26.5976 17.1189C26.6667 17.4066 26.6667 17.7124 26.6667 18.3238Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNotes);
export default __webpack_public_path__ + "static/media/invoice-notes.a1e63aa0f0afec14d8527e254247ab47.svg";
export { ForwardRef as ReactComponent };